import React, { useState } from 'react';
import { useTheme, useMediaQuery, Box, CssBaseline } from '@mui/material';
import AppBar from './AppBar';
import SideNav from './SideNav';

interface LayoutProps {
  children: React.ReactElement<{ checked: boolean; setChecked: React.Dispatch<React.SetStateAction<boolean>> }> | React.ReactElement<{ checked: boolean; setChecked: React.Dispatch<React.SetStateAction<boolean>> }>[]; 
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [open, setOpen] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const drawerWidth = 240;
  const appBarHeight = isMobile ? 56 : 64; // Adjust for mobile and desktop AppBar height

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const [checked, setChecked] = useState(true);

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      {/* App Bar */}
      <AppBar onMenuClick={handleDrawerToggle} checked={checked} setChecked={setChecked} />

      {/* Side Navigation */}
      {open && <SideNav open={open} onClose={handleDrawerToggle} isMobile={isMobile} checked={checked} setChecked={setChecked} />}

      {/* Main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflowX: 'hidden',
          padding: '80px 0px 0px !important',
          backgroundColor: '#F9FBFC',
          transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          // Fix template literal syntax in paddingTop
          paddingTop: `${appBarHeight + 24}px`, // 24px is extra space for spacing
          width: { sm: `calc(100% - ${open ? drawerWidth : 0}px)` },
        }}
      >
        {/* Pass checked and setChecked to children */}
        {React.Children.map(children, (child) =>
          React.isValidElement(child)
            ? React.cloneElement(child, { checked, setChecked } as any)
            : child
        )}
      </Box>
    </Box>
  );
};

export default Layout;